import Head from 'next/head'
import Seo, { SITE_URL } from '@comp/seo'
import Layout from '@comp/layout'
// Homepage with a guided access scenario and user-controlled feature previews.
import HomeV4 from '@comp/home/home-v4'

const seo = {
  en: {
    title: 'Monofor: Empowered Identity and Access',
    description:
      'IAM, PAM, IGA, and AI identity security in one platform: SSO, MFA, privileged access, certificate lifecycle, and governed AI agents.',
  },
  tr: {
    title: 'Monofor: Güçlendirilmiş Kimlik ve Erişim',
    description:
      'IAM, PAM, IGA ve AI kimlik güvenliği tek platformda: SSO, MFA, ayrıcalıklı erişim, sertifika yaşam döngüsü ve yönetilen AI ajanları.',
  },
}

type Props = { locale: string }

export default function Home({ locale }: Props) {
  const s = locale === 'tr' ? seo.tr : seo.en
  const basePath = locale === 'tr' ? '/tr' : ''
  return (
    <>
      <Seo title={s.title} description={s.description} path={basePath || '/'} />
      <Head>
        <link rel="alternate" hrefLang="en" href={SITE_URL} />
        <link rel="alternate" hrefLang="tr" href={`${SITE_URL}/tr`} />
        <link rel="alternate" hrefLang="x-default" href={SITE_URL} />
      </Head>
      <Layout>
        <HomeV4 />
      </Layout>
    </>
  )
}

export async function getStaticProps({ locale }: { locale: string }) {
  return { props: { locale: locale ?? 'en' } }
}
